<template>
  <v-menu offset-y v-model="show" :allow-overflow="true">
    <template v-slot:activator="{ on }">
      <v-text-field
        color="primary"
        v-model="item"
        v-on="on"
        :label="$i18n.t(label)"
        :loading="loading"
        :clearable="clearable"
        :rules="rules"
        autocomplete="nope"
        >Dropdown</v-text-field
      >
    </template>
    <v-list elevation="0" v-if="addreses.length > 0">
      <v-list-item
        v-for="(address, index) in addreses"
        :key="index"
        @click="select(address)"
      >
        <v-list-item-title>{{ address.name }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";
import { commonMixin } from "@/mixins/common";
import { Vue, Component, Watch } from "vue-property-decorator";

@Component({
  name: "MaterialType",
  props: {
    value: {
      default: false,
    },
    label: {
      default: "Material Type",
    },
    clearable: {
      default: false,
    },
    rules: {
      default: () => [],
    },
  },
  mixins: [Themeable, commonMixin],
})
export default class MaterialType extends (Vue, Themeable) {
  address = "";
  item = null;
  addreses = [
    { value: "41", name: "Auto Parts" },
    { value: "45", name: "Bardana jute or plastic" },
    { value: "18", name: "Building Materials" },
    { value: "3", name: "Cement" },
    { value: "4", name: "Chemicals" },
    { value: "16", name: "Coal And Ash" },
    { value: "6", name: "Container" },
    { value: "43", name: "Cotton seed" },
    { value: "5", name: "Electronics Consumer Durables" },
    { value: "7", name: "Fertilizers" },
    { value: "10", name: "Fruits And Vegetables" },
    { value: "11", name: "Furniture And Wood Products" },
    { value: "12", name: "House Hold Goods" },
    { value: "13", name: "Industrial Equipments" },
    { value: "17", name: "Iron sheets or bars or scraps" },
    { value: "24", name: "Liquids in drums" },
    { value: "15", name: "Liquids/Oil" },
    { value: "26", name: "Machinery new or old" },
    { value: "25", name: "Medicals" },
    { value: "46", name: "Metals" },
    { value: "27", name: "Mill Jute Oil" },
    { value: "21", name: "Others" },
    { value: "9", name: "Packed Food" },
    { value: "23", name: "Plastic Pipes or other products" },
    { value: "29", name: "powder bags" },
    { value: "22", name: "Printed books or Paper rolls" },
    { value: "8", name: "Refrigerated Goods" },
    { value: "1", name: "Rice or wheat or Agriculture Products" },
    { value: "14", name: "Scrap" },
    { value: "31", name: "Spices" },
    { value: "19", name: "Textiles" },
    { value: "20", name: "Tyres And Rubber Products" },
    { value: "2", name: "Vehicles or car" },
  ];
  loading = false;
  show = false;

  mounted() {
    this.onValueChange(this.value);
  }

  select(address) {
    this.address = address;
    if (address) this.item = address.name;
    else this.item = null;
  }

  clear() {
    this.item = null;
    this.address = "";
    this.$emit("input", {});
  }

  @Watch("value")
  onValueChange(val) {
    this.item = val;
  }

  @Watch("item")
  async onFilterChange(val) {
    this.item = val;
    this.$emit("input", this.item);
  }

  @Watch("addresses")
  onAddressChange(val) {
    if (val == null || val.length == 0) this.show = false;
  }

  onClick() {
    this.onAddressChange(this.addreses);
  }
}
</script>

<style scoped>
.filterBox {
  position: sticky;
  background: white;
  top: 0;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-bottom: 1px solid #dfdfdf;
}

.v-select-list {
  padding: 0;
}
.menuable__content__active,
.v-menu__content {
  background: white;
}
.v-select__selections {
  height: 32px;
}
.height32 {
  height: 32px;
}
.text-title {
  min-width: 60px;
  float: left;
  margin: 4px 0;
  line-height: 1.2;
  font-weight: 400;
  font-size: 14px;
}
.flag-img {
  float: left;
  margin-right: 10px;
  height: 20px;
  width: 24px;
  margin: 5px 10px 2px 0;
}
</style>
